import { Stack, Typography, useTheme } from "@mui/material";
import { Link } from "react-router";
import useClientContext from "../../../../context/useClientContext";
import { pageRoutes } from "../../../../routes";

const NavigateToInvitationEmailSettings = () => {
  const theme = useTheme();
  const { clientCode } = useClientContext();

  return (
    <Stack sx={{ mt: 2, width: "100%", alignItems: "center" }}>
      <Typography>
        {"Click "}
        <Link
          style={{ color: theme.palette.primary.main, textDecoration: "none" }}
          target="_blank"
          rel="noopener noreferrer"
          to={`/${clientCode}/${pageRoutes.investorRelations}/${pageRoutes.investorPortalSettings}?tab=invitation_email`}
        >
          here
        </Link>
        {" to view and or adjust the email template."}
      </Typography>
    </Stack>
  );
};

export default NavigateToInvitationEmailSettings;
